var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"color":"white","dark":"","elevation":"2"}},[_c('v-toolbar-title',[_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Dutch Bros","contain":"","src":"https://files.dutchbros.com/logos/primary_logo_blue_text.png","transition":"scale-transition","width":"150"}})],1),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }